import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-square-loading',
  templateUrl: './square-loading.component.html',
  styleUrls: ['./square-loading.component.scss']
})

export class SquareLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
